export default "__VITE_ASSET__NYAdq0XM__"